export const onPageTransitionEnd = () => {
  if (!globalThis.routerTransitionSubscribers) {
    return;
  }

  for (const subscriber of globalThis.routerTransitionSubscribers) {
    if (subscriber?.onTransitionEnd) {
      subscriber?.onTransitionEnd();
    }
  }

  document
    .querySelector('#page-transition-animation')
    ?.classList.remove('page-transition-animation__active');

  document
    .querySelector('#page-transition-animation')
    ?.classList.add('page-transition-animation__finished');
};
